import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  { path: '/', redirect: '/index' },

  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue')
  },
  // 加入企业
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/join.vue')
  },
  //修改个人信息
  {
    path: '/join/edit',
    name: 'joinEdit',
    component: () => import(/* webpackChunkName: "login" */ '../views/setting/joinEdit.vue')
  },
  // 首页
  {
    path: '/index',
    name: 'index',
    redirect: '/index/home',
    component: () => import(/* webpackChunkName: "fir" */ '../views/home/index.vue'),
    children: [
      // 首页
      {
        path: '/index/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "sec" */ '../views/home/home.vue')
      },
      //项目(流程)
      {
        path: '/projectStep',
        name: 'projectStep',
        redirect: '/projectStep/step',
        component: () => import(/* webpackChunkName: "pro" */ '../views/project/projectStep/projectStep.vue'),
        children: [
          // 项目-流程
          {
            path: '/projectStep/step',
            name: 'step',
            component: () => import(/* webpackChunkName: "pro" */ '../views/project/projectStep/step/step.vue')
          },
          // 使用帮助
          {
            path: '/projectStep/help',
            name: 'help',
            component: () => import(/* webpackChunkName: "hel" */ '../views/project/projectStep/help/help.vue')
          },
          // 反馈列表
          {
            path: '/projectStep/problem',
            name: 'problem',
            component: () => import(/* webpackChunkName: "hel" */ '../views/project/projectStep/problem/problem.vue')
          },


        ]
      },
      //项目
      {
        path: '/project',
        name: 'project',
        redirect: '/project/index',
        component: () => import(/* webpackChunkName: "pro" */ '../views/topBar/project.vue'),
        children: [
          // 项目-首页
          {
            path: '/project/index',
            name: 'projectIndex',
            component: () => import(/* webpackChunkName: "pro" */ '../views/project/index.vue')
          },
          // 项目-关注项目
          {
            path: '/project/attention',
            name: 'projectAttention',
            component: () => import(/* webpackChunkName: "pro" */ '../views/project/attention.vue')
          },
          // 项目-分类项目
          {
            path: '/project/classify',
            name: 'projectClassify',
            component: () => import(/* webpackChunkName: "proc" */ '../views/project/classify.vue')
          },
          // 项目-归档
          {
            path: '/project/save',
            name: 'projectSave',
            component: () => import(/* webpackChunkName: "proc" */ '../views/project/save.vue')
          },
          {
            // 项目-新增
            path: '/project/add',
            name: 'projectAdd',
            redirect: '/project/add/task',
            component: () => import(/* webpackChunkName: "pro" */ '../views/project/add.vue'),
            children: [
              // 项目-新增-任务
              {
                path: '/project/add/task',
                name: 'projectIndexTask',
                component: () => import(/* webpackChunkName: "proa" */ '../views/project/task/task.vue')
              },
              // 项目-查看-任务
              {
                path: '/project/details/task',
                name: 'projectDetailsTask',
                component: () => import(/* webpackChunkName: "proa" */ '../views/project/task/task.vue')
              },
              // 项目-查看-文件
              {
                path: '/project/details/file',
                name: 'file',
                component: () => import(/* webpackChunkName: "pro" */ '../views/project/file/file.vue')
              },
              // 项目-查看-统计
              {
                path: '/project/details/statistics',
                name: 'statistics',
                component: () => import(/* webpackChunkName: "proa" */ '../views/project/statistics/statistics.vue')
              },
              // 项目-查看-日志
              {
                path: '/project/details/logs',
                name: 'logs',
                component: () => import(/* webpackChunkName: "prob" */ '../views/project/log/logs.vue')
              },
              // 项目-查看-财务
              {
                path: '/project/details/finance',
                name: 'finance',
                component: () => import(/* webpackChunkName: "prob" */ '../views/project/finance/finance.vue')
              },
            ]
          },
        ]
      },
      //财务
      {
        path: '/financeTop',
        name: 'financeTop',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/financeTop.vue')
      },
      //行政
      {
        path: '/adminTop',
        name: 'adminTop',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/adminTop.vue')
      },
      //工具
      {
        path: '/tools',
        name: 'tools',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/tools.vue')
      },
      // 业务
      {
        path: '/businessTop',
        name: 'businessTop',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/businessTop.vue')
      },
      //客户管理
      {
        path: '/clientManage',
        name: 'clientManage',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/clientManage.vue')
      },
      //知识库
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import(/* webpackChunkName: "top" */ '../views/topBar/knowledge.vue')
      },
      //备忘录
      {
        path: '/todo',
        name: 'todo',
        component: () => import(/* webpackChunkName: "top" */ '../views/todo/todo.vue')
      },
      //自动审批
      {
        path: '/mySql',
        name: 'mySql',
        component: () => import(/* webpackChunkName: "top" */ '../views/setting/mySql.vue')
      },
      //系统公告,详情
      {
        path: '/message/details',
        name: 'messageDetails',
        component: () => import(/* webpackChunkName: "top" */ '../views/message/details.vue')
      },
      //管理-组织架构
      {
        path: '/admin/organization',
        name: 'organization',
        component: () => import(/* webpackChunkName: "top" */ '../views/admin/organization.vue')
      },
      //管理-统计
      {
        path: '/admin/statistics',
        name: 'statistics',
        component: () => import(/* webpackChunkName: "top" */ '../views/admin/statistics.vue')
      },
      //管理-统计(业务考核)
      {
        path: '/admin/assessmentStatistics',
        name: 'assessmentStatistics',
        component: () => import(/* webpackChunkName: "top" */ '../views/admin/assessmentStatistics.vue')
      },
      //管理-OA(项目设置)
      {
        path: '/admin/projectSet',
        name: 'projectSet',
        component: () => import(/* webpackChunkName: "topc" */ '../views/admin/projectSet.vue')
      },
      //管理-OA(审批设置)
      {
        path: '/admin/approveSet',
        name: 'approveSet',
        component: () => import(/* webpackChunkName: "topc" */ '../views/admin/approveSet.vue')
      },
      //管理-OA(考勤管理)
      {
        path: '/admin/punchAdmin',
        name: 'punchAdmin',
        component: () => import(/* webpackChunkName: "topc" */ '../views/admin/punchAdmin.vue')
      },

      // 修改个人信息
      {
        path: '/setting/changeUserInfo',
        name: 'changeUserInfo',
        component: () => import(/* webpackChunkName: "topc" */ '../views/setting/changeUserInfo.vue')
      },
      //我的流程
      {
        path: '/myFlow',
        name: 'myFlow',
        component: () => import(/* webpackChunkName: "topc" */ '../views/topBar/myFlow.vue')
      },
    ]
  }

]


// 解决路由catch报错
// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }
// 解决路由catch报错

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由拦截
router.beforeEach((to, from, next) => {
  if (
    to.name == 'login'
  )
    return next()
  const tokenStr = localStorage.getItem('btlh_process_token')
  // 为空返回登陆
  if (!tokenStr) {
    return next('/login')
  }
  // 不为空不拦截
  next()
})

export default router
